import { render, staticRenderFns } from "./purposeDate.vue?vue&type=template&id=50774a38&scoped=true"
import script from "./purposeDate.vue?vue&type=script&lang=js"
export * from "./purposeDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50774a38",
  null
  
)

export default component.exports